import { z } from 'zod';
import { agentChatModelSchema } from '../enums/agent.js';
import { StatusTypeSchema } from '../enums/status.js';

export const promptMessageSchema = z.object({
  role: z.enum(['system', 'user']),
  content: z.string(),
});
export type PromptMessage = z.infer<typeof promptMessageSchema>;

export const promptKindSchema = z.enum(['default', 'agent-system-prompt', 'compliance-check']);
export type PromptKind = z.infer<typeof promptKindSchema>;

export const promptListItemSchema = z.object({
  id: z.number(),
  identifier: z.uuid(),
  name: z.string(),
  description: z.string(),
  kind: promptKindSchema,
  status: StatusTypeSchema,
  version: z.number(),
  createdOn: z.coerce.date(),
  queriesSubmitted: z.number(),
});
export type PromptListItem = z.infer<typeof promptListItemSchema>;

export const promptDetailsSchema = z.object({
  id: z.number(),
  identifier: z.uuid(),
  name: z.string(),
  description: z.string(),
  kind: promptKindSchema,
  status: StatusTypeSchema,
  version: z.number(),
  messages: z.array(promptMessageSchema),
  inputSchema: z.record(z.string(), z.unknown()),
  isActive: z.boolean(),
  llmModel: agentChatModelSchema,
  structuredOutputSchema: z.record(z.string(), z.unknown()).nullable().optional(),
  createdOn: z.coerce.date(),
});
export type PromptDetails = z.infer<typeof promptDetailsSchema>;
